import React,{useContext,useState,useEffect} from 'react'
import FlexView from 'react-flexview/lib'
import { TextField, Grid, Divider, Button, MenuItem, Select, FormHelperText, IconButton } from '@material-ui/core'
import { PasswordInput } from '../Core/PasswordInput'
import { useForm, Controller } from 'react-hook-form'
import NewFillButton from '../Core/NewFillButton'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import AccountApi from '../../api/account.api'
import { awaitWithLoading, liabilityLimitPretty } from '../../services/utils'
import { EMAIL_REGEX } from '../../Constants'
import { SessionService } from '../../services/SessionService'
import { UserProfileContextStore } from "../../context/UserProfileContext";
import { SessionContextStore } from '../../context/SessionContext';
import { ApproveRefferalRequest } from './ApproveRefferalRequest';
import {AntSwitch} from "../Core/Buttons/AntSwitch"
import { SkywatchDialog } from "../PopUps/SkywatchDialog"



import './ManageProfile.scss'
import { FirebaseConfigKey, FirebaseService } from '../../services/FirebaseService'
import LocalizationService from '../../services/LocalizationService'
import BuyingInsuranceContext, { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import generalApi from '../../api/general.api'
import { UserApi } from '../../api/user.api'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import { GraphicEqOutlined } from '@material-ui/icons'
import { GreenButton } from '../Core/Buttons/GreenButton'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import { update } from 'lodash'

var classNames = require('classnames')

export const SpecialLimits = () => {
    const { register, triggerValidation, errors, getValues, control } = useForm({mode: 'onChange'})
    const sessionContext = React.useContext(SessionContextStore)
    const[hullEligibility, setHullEligibility] = useState(true)
    const[purchaseEligibility, setpurchaseEligibility] = useState(true)
    const [liabilityLimitOption, setLiabilityLimitOption] = useState([])
    const [showHullPopup, setshowHullPopup] = React.useState(false)
    const [showPurchasePopup, setshowPurchasePopup] = React.useState(false)
    const [selectedLiabilityMax, setSelectedLiabilityMax] = useState(null)



    React.useEffect(() => {
        const getLiabilitylimitOptions = async () => {
            let res = await generalApi.getLiabilitylimitOptions()
            if(res.ok) {
                setLiabilityLimitOption(res.data)
                const liabilityLimitAllow = res.data.filter(item => item.value == sessionContext.user.liabilityLimitAllow)[0]
                setSelectedLiabilityMax(liabilityLimitAllow)
 
            }
            else {
                EventEmitterService.dispatch(EventKey.ShowError, res)
            }
        }
        getLiabilitylimitOptions()
        setHullEligibility(sessionContext.user.hullEligibility)
        setpurchaseEligibility(sessionContext.user.purchaseEligibility)
    }, [sessionContext.user.liabilityLimitAllow, sessionContext.user.hullEligibility, sessionContext.user.purchaseEligibility])


    const onLiabilityChange = async (e) => {
        const option = liabilityLimitOption.filter(item => item.value == e.target.value)[0]
        if (!option) return
        setSelectedLiabilityMax(option)
        let res = await UserApi.updateLiabilityLimitDeclination(option.value)
        if(!res.ok) {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }



    const UpdateHullEligibility = async () => {
        const tempHull = !hullEligibility
        setHullEligibility(tempHull)
        let res = await UserApi.updateHullEligibility(hullEligibility)
        if(!res.ok) {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
        setshowHullPopup(false)
    }

    const UpdatePurchaseEligibility = async () => {
        const tempPurchase = !purchaseEligibility
        setpurchaseEligibility(tempPurchase)
        let res = await UserApi.updatePurchaseEligibility(purchaseEligibility)
        if(!res.ok) {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
        setshowPurchasePopup(false)
    }

    const onClose = async() =>{
        setshowHullPopup(false)
        setshowPurchasePopup(false)
    } 

    const onHullChange = async(val) =>{
        if (val){
            UpdateHullEligibility()
        }
        else{
            setshowHullPopup(true)
        }
    }


    const onPurchaseChange = async(val) =>{
        if (val){
            UpdatePurchaseEligibility()
        }
        else{
            setshowPurchasePopup(true)
        }
    }




    return (
        <FlexView column>

        <Grid spacing={3}>
        <h1>Special Limits</h1>  
        </Grid>


        <FlexView className="margin-top-basic" container spacing={1}>
            <Grid style={{marginRight:"80px"}}><h3>Hull Eligibility</h3></Grid>
                    <Grid className='margin-top-basic' item xs={2} >
                    <AntSwitch 
                        onChange={async (event) => {
                        const val = event.target.checked;
                        await onHullChange(val)  }} 
                        checked={hullEligibility} 
                    />                    
                    </Grid>           
        </FlexView>
        <br></br>

        <FlexView className="margin-top-basic" container spacing={5}>
            <Grid style={{marginRight:"33px"}}><h3>Purchase Eligibility</h3></Grid>
                    <Grid className='margin-top-basic' item xs={2} >
                    <AntSwitch 
                        onChange={async (event) => {
                        const val = event.target.checked;
                        await onPurchaseChange(val)  }}
                        checked={purchaseEligibility} 
                    />      
                    </Grid>           
        </FlexView>

        <br/><br/>
        <Grid>
            <Grid ><h3>Max liability limit allowance:</h3></Grid>

                <FlexView className="margin-top-basic" container spacing={0} >

                    <Grid item xs={10} sm={2} style={{marginRight:"50px"}}>
                        <TextField
                            select
                            size="small"
                            InputProps={{ disableUnderline: true, className: 'lightgrayblue' }}
                            className="margin-top-basic"
                            variant="outlined"
                            onChange={(event) => {
                                onLiabilityChange(event);
                            }}
                            value={selectedLiabilityMax?.value || ""}  
                            fullWidth
                        >
                            {liabilityLimitOption.map(option => (
                                <MenuItem
                                    className="radio-liability"
                                    key={option.value}
                                    value={option.value}
                                >
                                    {liabilityLimitPretty(option.value)}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>            
                </FlexView>
        </Grid>
        <SkywatchDialog 
            open={showHullPopup} 
            maxWidth={'xs'}
            closeDialog={() => onClose()}
            closeTitle={'Approved'}>
                <div className='text-title blue bold text-center' style={{textAlign: 'center'}}>Please Notice</div>
                <br/>
                <div>
                    You are about to restrict the user's hull, preventing them from purchasing a policy with hull coverage, and cancel all hull coverage in their next renewal (if applicable).
                </div>
                <NewFillButton onClick={()=> UpdateHullEligibility()}>
                    Approve
                </NewFillButton>

        </SkywatchDialog>

        <SkywatchDialog 
            open={showPurchasePopup} 
            maxWidth={'xs'}
            closeDialog={() => onClose()}
            closeTitle={'Approved'}>
                <div className='text-title blue bold text-center' style={{textAlign: 'center'}}>Please Notice</div>
                <br/>
                <div>
                You are about to restrict the user from making purchases. They will no longer be able to purchase a policy.
                </div>
                <NewFillButton onClick={()=> UpdatePurchaseEligibility()}>
                    Approve
                </NewFillButton>

        </SkywatchDialog>


        </FlexView>
        
    )
}